import classnames from 'classnames'

import BranchLabel from '../../../../common/BranchLabel/BranchLabel'
import type {Props} from '../../../../common/BranchLabel/BranchLabel.types'

import styles from './PipelineBranchLabel.css'

function PipelineBranchLabel({className, ...props}: Props) {
  const classes = classnames(styles.branchLabel, className)

  return (
    <BranchLabel {...props} className={classes} nameClassName={styles.branchLabelName} withIcon />
  )
}

export default PipelineBranchLabel
